module.exports = __webpack_public_path__ + "static/robotsim1-cc8dd9ea0729a9934a5ac4bc50398706.jpg";